import { createButtonFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-button'
import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import createLibraryElementStructure from 'client/utils/createLibraryElements'
import {
  createDefaultEntityStructure,
  createMenuFromLibrary,
} from 'client/utils/createStructureUtils'
import { BaseEntityWithChildIdsInterface } from 'common/types/entities/EntityInterface'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { EntitiesStructure } from 'common/types/Page'
import { CommonLibraryElementsCreator } from './common-library-elements-creator'

function hasMethod<T, K extends PropertyKey>(
  obj: T,
  method: K,
): obj is T & Record<K, (...args: unknown[]) => EntitiesStructure> {
  return typeof (obj as Record<K, unknown>)[method] === 'function'
}

export type CreatorArgs = {
  container: OldEntityWithChildIds | BaseEntityWithChildIdsInterface
  locale: string
  position: number
}

export class CommonLibraryElementsStructuresCreator {
  constructor(createElement = CommonLibraryElementsCreator) {
    this.createElement = new createElement()
  }
  protected createElement: CommonLibraryElementsCreator

  // ------------------------------
  // NOTE: entity structure creators
  // ------------------------------
  protected [LibraryElementEnum.LibraryButton](args: CreatorArgs) {
    return createButtonFromLibrary({
      createButton: this.createElement[LibraryElementEnum.LibraryButton],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryField](args: CreatorArgs) {
    return createDefaultEntityStructure({
      createEntity: this.createElement[LibraryElementEnum.LibraryField],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryForm](args: CreatorArgs) {
    return createDefaultEntityStructure({
      createEntity: this.createElement[LibraryElementEnum.LibraryForm],
      ...args,
    })
  }
  protected [LibraryElementEnum.LibraryMenu](args: CreatorArgs) {
    return createMenuFromLibrary({
      createMenu: this.createElement[LibraryElementEnum.LibraryMenu],
      ...args,
    })
  }
  // protected [LibraryElementEnum.LibraryPopup](args: CreatorArgs) {
  //   return createDefaultEntityStructure(
  //     {
  //       createEntity: this.createElement[LibraryElementEnum.LibraryPopup],
  //       ...args
  //     }
  //   )
  // }
  // ------------------------------

  public create = ({
    libraryElementType,
    ...args
  }: { libraryElementType: LibraryElementEnum } & CreatorArgs) => {
    if (hasMethod(this, libraryElementType)) {
      return this[libraryElementType](args)
    } else {
      return createLibraryElementStructure({
        libraryElementType,
        ...args,
      })
    }
  }
}
